/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offer_Tab_ArchiveInputs */

const en_offer_tab_archive = /** @type {(inputs: Offer_Tab_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

const pl_offer_tab_archive = /** @type {(inputs: Offer_Tab_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiwum`)
};

/**
* | output |
* | --- |
* | "Archive" |
*
* @param {Offer_Tab_ArchiveInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offer_tab_archive = /** @type {((inputs?: Offer_Tab_ArchiveInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offer_Tab_ArchiveInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offer_tab_archive(inputs)
	return en_offer_tab_archive(inputs)
});